import React, { useState, useRef, useEffect, } from 'react';
import { useParams } from "react-router-dom";

import Loader from 'react-loader-spinner';
import { withFirebase } from '../firebase';


const TeamListForm = (props) => {

    const { onClose, showModal, isOpen } = props

    const inputTitleRef = useRef();


    useEffect(() => {
        inputTitleRef.current.focus();
    }, [isOpen])

    const { tournament_uid } = useParams(); // tournament uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const [saving, setSaving] = useState(false)
    const [title, setTitle] = useState('');

    const hideForm = () => {
        onClose();
    }

    const invalid = title === '';

    const onSubmit = (e) => {
        e.preventDefault();
        if (!invalid && !saving) {
            setSaving(true);

            props.firebase.teamCollection(userId, tournament_uid).add({
                userUid: userId,
                tournamentUid: tournament_uid,
                createdAt: props.firebase.timestamp(),
                title: title
            })
                .then((result) => {
                    setSaving(false);
                    hideForm();
                    // props.showModal("", "El Torneo se creó con éxito.");
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    setSaving(false);
                    showModal("Error", "No se pudo crear el Equipo");
                });
        }
    }


    return (

        <div className="">
            <span className="font-weight-bolder ml-2">Añadir nuevo equipo</span>

            <form onSubmit={onSubmit}>

                <div className="row m-0">
                    <div className="col row pl-0 pr-0 m-0">

                        <div className="col-12 p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="title">Nombre del Equipo</label>
                            <input ref={inputTitleRef} className="form-control form-control-sm autofocus" value={title} type="text" onChange={(e) => setTitle(e.target.value)} id="title" autoComplete="off" />
                        </div>

                    </div>

                    {(!saving) ?
                        <div className="col-12 d-flex flex-row-reverse p-0 mt-2">
                            <button disabled={invalid} type="submit" className="col-auto btn btn-sm btn-success m-1">Guardar</button>
                            <button onClick={onClose} className="col-auto btn btn-sm btn-secondary m-1">Cancelar</button>
                        </div>
                        :
                        <div className="col-12 d-flex flex-row-reverse p-0 mt-2">
                            <Loader className=""
                                type="ThreeDots"
                                color="#263238"
                                height={39}
                                width={50}
                                timeout={0} />
                        </div>
                    }
                </div>

            </form>
        </div>
    )

}

export default withFirebase(TeamListForm);
